<template>
    <section id="event" class="gh-summit-section l-snapshot">
        <div class="container">
            <div class="ghSnapshots">
                <h3 class="section-heading gh-heading">Snapshot of the Summit</h3>
                <p class="gh-section-subheading">The 2022 Suicide Prevention Summit will be delivered via live webinar sessions during September 10 & 11, 2022. Sessions will be available on-demand (i.e., you can watch recordings) until Sunday, November 6*.</p>
                <div class="gh-items" :gutter="32">
                    <div v-for="(snapshot, index) in $options.snapshots"
                        :key="index"
                        :class="'ghSnapshot-item ' + 'ghSnapshot-item-'+index">
                        <div class="ghSnapshot-item-inner">
                            <div class="gh-item__image">
                                <img class="snapshot-image" :src="'/images/suicidePreventionSummit/' + snapshot.icon" alt="">

                            </div>
                            <h4 class="ghSnapshot-title gh-lightPink" v-html="snapshot.title"></h4>
                            <h3 class="ghSnapshot-description" v-html="snapshot.description"></h3>
                        </div>
                    </div>
                </div>
            </div>
            <p class="mt-1 gh-hint">*By choosing the free registration option, you will enjoy on-demand access to video recordings for 7 days. By choosing the £10 registration option, you will enjoy extended on-demand access to video recordings until Sunday, November 6, 2022. For more details, please see our <a  @click="showDialog"><u>Terms & Conditions</u></a>.</p>
        </div>
        <gh-terms :dialogVisible="dialogVisible" @hide="dialogVisible=false" />
    </section>
</template>

<script>
    import ghTerms from './TermsRegistration';

    export default {
        data() {
            return {
                dialogVisible: false
            }
        },

        components: {
            ghTerms
        },

        methods: {
            showDialog() {
                this.dialogVisible = true;
            }   
        },

        snapshots: [
            {
                title: 'Choose what you pay',
                description: 'You can register for free - or pay only £10 (all of which goes to charity) to enjoy exclusive perks.',
                icon: 'snapshot-icon1.svg'
            },
            {
                title: 'Live Q&A',
                description: 'Interact with presenters through live Q&A sessions.',
                icon: 'snapshot-icon2.svg'
            },
            {
                title: 'Live Webinars',
                description: 'Access live, interactive webinars facilitated by top experts.',
                icon: 'snapshot-icon3.svg'
            },
            {
                title: 'Recorded Sessions',
                description: 'Access session recordings*, on-demand, 24/7 – so you don’t miss out on anything.',
                icon: 'snapshot-icon4.svg'
            },
            {
                title: 'Culturally Appropriate',
                description: 'Strategies to best support a range of client populations at risk of suicide.',
                icon: 'snapshot-icon5.svg'
            },
            {
                title: 'Top Experts',
                description: 'Learn directly from leading suicide prevention experts.',
                icon: 'snapshot-icon6.svg'
            },
            {
                title: '10 CPD Hours',
                description: 'Receive personalised CPD Certificates for each session you attend.',
                icon: 'snapshot-icon7.svg'
            },
            {
                title: 'Proceeds Go to Charity',
                description:  'All proceeds from registrations will be donated to the BPS.',
                icon: 'snapshot-icon8.svg'
            }
        ]
    }
</script>

<style scoped lang="scss">
    .l-snapshot {
      background: #F5F7FA;
    }

    .gh-summit-section {
        padding: 2rem 0;
    }
    
    .gh-hint {
        text-align: center;
        font-family: 'proxima-nova', sans-serif;
        font-size: 14px;
      a {
        cursor: pointer;
      }
    }

    .gh-items {
        margin-top: 2rem;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
    }
    .el-col {
        padding:0;
    }

    .gh-heading {
        text-align: center;
        color: #474f59;
        padding-bottom: 1rem;
        margin-bottom: 20px;
    }

    .gh-section-subheading {
        font-size: 1.3rem;
        max-width: 890px;
        margin: 0 auto;
        text-align: center;
        font-weight: 600;
        color: #474f59;
    }

    .ghSnapshot-item {
        width: 300px;
        text-align: center;
        vertical-align: middle;
        height: 170px;

        .ghSnapshot-item-inner {
            top: 50%;
            left: 50%;
            height: 109%;
            .gh-item__image {
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    height: 45px;
                    margin-bottom: 0;
                }
            }
            .ghSnapshot-title {
                padding-bottom: 1rem;
                line-height: 1;
                font-size: 1.4rem;
            }
            .ghSnapshot-description {
                font-weight: 500;
                transition: 0.3s;
                font-size: 16px;
                padding: 0 1.5rem;
                color: #474f59;
                font-family: 'proxima-nova', sans-serif;
              line-height: 1.3;
            }
        }

        @media screen and (max-width: '1280px') {
            height: 235px;
            .ghSnapshot-item-inner {
                .ghSnapshot-description {
                    padding: 0 1rem;
                }
            }
        }

        @media screen and (max-width: '1024px') {
            .ghSnapshot-icon-text {
                height: 45px ;
            }
        }

         @media screen and (max-width: '768px') {
            height: auto;
            padding-bottom: 2rem;
        }
    }
    @media screen and (max-width: '768px') {
        .gh-heading {
            padding-bottom: 0;
        }
    }
</style>
